import { format, parseISO, startOfDay } from "date-fns";

export const timeFormat = "HH:mm";
export const timeFormatV2 = "HH:mm a";

// An open call closes at an instant, not on a day, so its deadline is always
// shown with a time. It lives here rather than beside the agent dashboard
// because the public open call page shows the same deadline in the same shape.
// Matches the Open Calls designs (12/07/23, 12:00PM).
export const DEADLINE_FORMAT = "dd/MM/yy, h:mma";

export const formatDate = (
  date: Date | string | null | undefined,
  dateFormat = "dd LLLL yyyy",
) => {
  if (!date) {
    return "TBC";
  }
  if (typeof date === "string") {
    return format(parseISO(date), dateFormat);
  } else {
    return format(date, dateFormat);
  }
};

export const formatDisplayDate = (
  date: Date | string,
  dateFormat = "dd LLLL yyyy",
) => {
  const formattedDate =
    typeof date === "string"
      ? format(parseISO(date), dateFormat)
      : format(date, dateFormat);
  return format(new Date(formattedDate), "dd/MM/yyyy");
};

export const isBetween = (before: Date, current: Date, after: Date) => {
  const startOfBefore = startOfDay(before);
  const startOfCurrent = startOfDay(current);
  const startOfAfter = startOfDay(after);

  return startOfBefore <= startOfCurrent && startOfCurrent <= startOfAfter;
};
